import { useQuery, QueryKey } from '@tanstack/react-query'
import { useContext } from 'react'
import ApiContext from '../../context/ApiContext'
import AuthContext from '../../context/AuthContext'
import { getAuth } from 'firebase/auth'

export const getUpcomingInvoiceQueryKey = (companyId?: string): QueryKey => ['upcomingInvoice', companyId]

type UpcomingInvoiceResult = {
	customerBalance: number
	currency: string
	nextBillingAnchor: number | null
}

type UseUpcomingInvoiceResult = {
	upcomingInvoice: UpcomingInvoiceResult | null | undefined
	isLoading: boolean
	error: Error | null
}

const useUpcomingInvoice = (): UseUpcomingInvoiceResult => {
	const apiContext = useContext(ApiContext)
	const authContext = useContext(AuthContext)
	const auth = getAuth()
	const companyId = authContext.company?.id

	const { data, isLoading, error } = useQuery({
		queryKey: getUpcomingInvoiceQueryKey(companyId),
		queryFn: async ({ signal }): Promise<UpcomingInvoiceResult | null> => {
			const idToken = await auth.currentUser?.getIdToken(true)
			const response = await fetch(`${apiContext.apiUrl}/companies/${companyId}/upcoming-invoice`, {
				headers: {
					Authorization: `Bearer ${idToken}`,
				},
				signal,
			})

			if (response.status === 404) {
				return null
			}

			if (!response.ok) {
				throw new Error(await response.text())
			}

			return response.json()
		},
	})
	return { upcomingInvoice: data, isLoading, error }
}

export default useUpcomingInvoice
